enum RegistrationFormStep {
    Register = 'register',
    RegisterVerify = 'registerVerify',
    RegisterSuccess = 'registerSuccess',
}

export default RegistrationFormStep
